import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_3 = ["disabled", "min", "max"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { ref, watch } from 'vue';
import TooltipComponent from '@/components/common/TooltipComponent/TooltipComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePickerComponent',
  props: {
  label: {
    type: String,
    default: 'Select a date',
  },
  minDate: {
    type: String,
    default: '',
  },
  maxDate: {
    type: String,
    default: '',
  },
  id: {
    type: String,
  },
  modelValue: {
    type: String,
    default: '',
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  tooltip: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const selectedDate = ref(props.modelValue);
const inputId = `date-picker-${Math.random().toString(36).substr(2, 9)}`;

watch(selectedDate, (newValue) => {
  const dateToNumber = Date.parse(newValue)
  if(props.minDate!=''){
    const minDateToNumber = Date.parse(props.minDate);
    if(dateToNumber-minDateToNumber<0){
      selectedDate.value = props.minDate;
    }
  }
  if(props.maxDate!=''){
    const maxDateToNumber = Date.parse(props.maxDate);
    console.log(maxDateToNumber-dateToNumber)
    if(maxDateToNumber-dateToNumber<0){
      selectedDate.value = props.maxDate;
    }
  }
  emit('update:modelValue', newValue);
});

watch(
    () => props.modelValue,
    (newValue) => {
      selectedDate.value = newValue;
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: inputId,
        class: "input_label"
      }, [
        _createElementVNode("span", null, _toDisplayString(__props.label), 1),
        (__props.tooltip && !__props.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(TooltipComponent, {
                text: __props.tooltip,
                position: "top"
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        disabled: __props.disabled,
        id: inputId,
        type: "date",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
        min: __props.minDate,
        max: __props.maxDate,
        class: _normalizeClass([[{ 'is-placeholder': selectedDate.value=='' }, { 'has-error': __props.hasError }], "input-field"])
      }, null, 10, _hoisted_3), [
        [_vModelText, selectedDate.value]
      ])
    ]),
    (__props.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})